import { render } from "./ToolbarAddIncident.vue?vue&type=template&id=42dea9f0&ts=true"
import script from "./ToolbarAddIncident.vue?vue&type=script&lang=ts"
export * from "./ToolbarAddIncident.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__